<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Pharmacy",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Pharmacy",
            items: [
               {
                  text: "Pharmacy",
                  href: "/pharmacies",
               },
               {
                  text: "Edit Pharmacy",
                  active: true,
               },        
            ],

            collecting_range: '',
            pharmacy: {
               id: "",
               name : "",
               address: "",
               mobile: "",
               email: "",   
            },

            password_confirmation: '',
            password: '',

            countries: [],

            image: "",
            preview_image: "",
            pharmacy_location: "",
            pharmacy_marker: { position: { lat: '', lng: '' } },
            pharmacy_center: { lat: '', lng: '' },
            pharmacy_current_place: null,

            pharmacy_mapOptions: {
               disableDefaultUI: true,
            },
            computed: {
               collectingRangeWithoutUnit() {
                  return this.collecting_range.replace(/\s*km\s*$/, '');    
               },
            },

            errors: {},
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
      },

      created() {
         this.fetchPharmacy();
      },

      methods: {


         fetchPharmacy(){

            let url = "clinic/clinic/pharmacy/details?id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;

               // Use responseData.pharmacy and responseData.bookings_count
               this.pharmacy =  responseData.pharmacy;
               this.pharmacy_marker.position.lat = parseFloat(responseData.pharmacy.latitude);
               this.pharmacy_marker.position.lng = parseFloat(responseData.pharmacy.longitude); 


               this.pharmacy_center.lat = parseFloat(responseData.pharmacy.latitude);
               this.pharmacy_center.lng = parseFloat(responseData.pharmacy.longitude); 

               if (responseData.pharmacy.address) {
                  this.pharmacy_location = responseData.pharmacy.address;
               }

               this.collecting_range = responseData.pharmacy.collecting_range + " km";

               //this.PharmacyfetchPlace(pharmacy_center);

               //console.log(res.data.data);


            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));
         },

         pharmacyUpdate(){
            //console.log('PharmacyUpdate method called');

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/clinic/updatePharmacy";

            let formData = new FormData();
            formData.append("id", this.pharmacy.id);
            formData.append("name", this.pharmacy.name);
            formData.append("email", this.pharmacy.email);
            formData.append("mobile", this.pharmacy.mobile);
            formData.append("address", this.pharmacy_location);
            formData.append("country_code", this.pharmacy.country_code_id); 
            formData.append("latitude", this.pharmacy_marker.position.lat);
            formData.append("longitude", this.pharmacy_marker.position.lng);
            if(this.image) {
               formData.append('image', this.image);
            }

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false))



         },
         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         changePassword(){


            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/clinic/pharmacy/change-password";
            let formData = new FormData();
            formData.append("id", this.pharmacy.id);
            formData.append("password", this.password);
            formData.append("password_confirmation", this.password_confirmation);

            this.loading = true;

            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'pharmacies' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               this.fetchPharmacy();


         },
        
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         
         //sets the position of marker when dragged
         pharmacyHandleMarkerDrag(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         pharmacyPanToMarker() {
            this.$refs.pharmacyMapRef.panTo(this.pharmacy_marker.position);
            this.$refs.pharmacyMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         pharmacyHandleMapClick(e) {
            this.pharmacy_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         pharmacySetPlace(place) {
            this.pharmacy_current_place = place;
            if(this.pharmacy_current_place) {
               const marker = {
                  lat: this.pharmacy_current_place.geometry.location.lat(),
                  lng: this.pharmacy_current_place.geometry.location.lng(),
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = place.formatted_address;
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

            /*pharmacyfetchPlace(pharmacy_center) {
            if (this.pharmacy_center) {
               const marker = {
                     lat: this.pharmacy_center.lat,
                     lng: this.pharmacy_center.lng,
               };
               this.pharmacy_center = marker;
               this.pharmacy_marker.position = marker;
               this.pharmacy_location = pharmacy_center.formatted_address;
            }
         },*/
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "pharmacyUpdate">
                        
                        <div class="row">
                           
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone</label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="pharmacy.country_code_id"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                              <b-form-input v-model="pharmacy.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                              <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           </b-col>

                           
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                    <img class="avatar-md mb-2" v-if="pharmacy.image" :src="$image_url + pharmacy.image" alt="">
                                 <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                                 <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>
                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="pharmacySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="pharmacy_location"/>
                              
                              <GmapMap v-if="pharmacy_location || (pharmacy_marker.position.lat && pharmacy_marker.position.lng)"
                                 :center="pharmacy_center"
                                 :zoom="18"
                                 map-style-id="pharmacy-roadmap"
                                 :options="pharmacy_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="pharmacyMapRef"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"
                                 @click="pharmacyHandleMapClick">
                                    <GmapMarker
                                       :position="pharmacy_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="pharmacyHandleMarkerDrag"
                                       @click="pharmacyPanToMarker"
                                    />
                              </GmapMap>        
                              <div v-if="errors.address" class="invalid-feedback d-block">
                                 <p class="mb-0" v-for="(val, i) in errors.address" :key="i">{{ val }}</p>
                              </div>                     
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="pharmacy_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <!-- <b-col md="4" xl="4" class="form-group">
                              <label class="control-label">Collecting Range <span class="text-danger">*</span></label>
                              <b-form-input v-model="collecting_range"> </b-form-input>
                           </b-col> -->
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>

                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "changePassword">
                        <h4 class="font-size-16 mb-4">Change Password</h4>
                        <div class="row">

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'pharmacies' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
